import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = ({ isActive, ...rest }) => {
  return isActive ? (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M2.55078 4.5C2.61472 3.84994 2.75923 3.41238 3.08582 3.08579C3.67161 2.5 4.61442 2.5 6.50004 2.5C8.38565 2.5 9.32846 2.5 9.91425 3.08579C10.5 3.67157 10.5 4.61438 10.5 6.5C10.5 8.38562 10.5 9.32843 9.91425 9.91421C9.32846 10.5 8.38565 10.5 6.50004 10.5C4.61442 10.5 3.67161 10.5 3.08582 9.91421C2.77645 9.60484 2.63047 9.19589 2.56158 8.60106"
        stroke="#F59C53"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M21.4493 15.5C21.3853 14.8499 21.2408 14.4124 20.9142 14.0858C20.3284 13.5 19.3856 13.5 17.5 13.5C15.6144 13.5 14.6716 13.5 14.0858 14.0858C13.5 14.6716 13.5 15.6144 13.5 17.5C13.5 19.3856 13.5 20.3284 14.0858 20.9142C14.6716 21.5 15.6144 21.5 17.5 21.5C19.3856 21.5 20.3284 21.5 20.9142 20.9142C21.2408 20.5876 21.3853 20.1501 21.4493 19.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.5 17.5C2.5 15.6144 2.5 14.6716 3.08579 14.0858C3.67157 13.5 4.61438 13.5 6.5 13.5C8.38562 13.5 9.32843 13.5 9.91421 14.0858C10.5 14.6716 10.5 15.6144 10.5 17.5C10.5 19.3856 10.5 20.3284 9.91421 20.9142C9.32843 21.5 8.38562 21.5 6.5 21.5C4.61438 21.5 3.67157 21.5 3.08579 20.9142C2.5 20.3284 2.5 19.3856 2.5 17.5Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M13.5 6.5C13.5 4.61438 13.5 3.67157 14.0858 3.08579C14.6716 2.5 15.6144 2.5 17.5 2.5C19.3856 2.5 20.3284 2.5 20.9142 3.08579C21.5 3.67157 21.5 4.61438 21.5 6.5C21.5 8.38562 21.5 9.32843 20.9142 9.91421C20.3284 10.5 19.3856 10.5 17.5 10.5C15.6144 10.5 14.6716 10.5 14.0858 9.91421C13.5 9.32843 13.5 8.38562 13.5 6.5Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M2.7959 4.5C2.85984 3.84994 3.00435 3.41238 3.33094 3.08579C3.91673 2.5 4.85953 2.5 6.74515 2.5C8.63077 2.5 9.57358 2.5 10.1594 3.08579C10.7452 3.67157 10.7452 4.61438 10.7452 6.5C10.7452 8.38562 10.7452 9.32843 10.1594 9.91421C9.57358 10.5 8.63077 10.5 6.74515 10.5C4.85953 10.5 3.91673 10.5 3.33094 9.91421C3.02157 9.60484 2.87558 9.19589 2.8067 8.60106"
        stroke="#888888"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M21.6944 15.5C21.6304 14.8499 21.4859 14.4124 21.1593 14.0858C20.5735 13.5 19.6307 13.5 17.7451 13.5C15.8595 13.5 14.9167 13.5 14.3309 14.0858C13.7451 14.6716 13.7451 15.6144 13.7451 17.5C13.7451 19.3856 13.7451 20.3284 14.3309 20.9142C14.9167 21.5 15.8595 21.5 17.7451 21.5C19.6307 21.5 20.5735 21.5 21.1593 20.9142C21.4859 20.5876 21.6304 20.1501 21.6944 19.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.74512 17.5C2.74512 15.6144 2.74512 14.6716 3.3309 14.0858C3.91669 13.5 4.8595 13.5 6.74512 13.5C8.63074 13.5 9.57354 13.5 10.1593 14.0858C10.7451 14.6716 10.7451 15.6144 10.7451 17.5C10.7451 19.3856 10.7451 20.3284 10.1593 20.9142C9.57354 21.5 8.63074 21.5 6.74512 21.5C4.8595 21.5 3.91669 21.5 3.3309 20.9142C2.74512 20.3284 2.74512 19.3856 2.74512 17.5Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M13.7451 6.5C13.7451 4.61438 13.7451 3.67157 14.3309 3.08579C14.9167 2.5 15.8595 2.5 17.7451 2.5C19.6307 2.5 20.5735 2.5 21.1593 3.08579C21.7451 3.67157 21.7451 4.61438 21.7451 6.5C21.7451 8.38562 21.7451 9.32843 21.1593 9.91421C20.5735 10.5 19.6307 10.5 17.7451 10.5C15.8595 10.5 14.9167 10.5 14.3309 9.91421C13.7451 9.32843 13.7451 8.38562 13.7451 6.5Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default Icon;
